import script from "./AppLogout.vue?vue&type=script&lang=js"
export * from "./AppLogout.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__